module.exports = __webpack_public_path__ + "img/la_logo.ebd38b05.png";